var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{staticClass:"empty-image",attrs:{"src":require("@/assets/images/empty.png"),"alt":""}}),_c('p',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }